import * as React from 'react';

class rangeSlider extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.componentName = "[rangeSlider.jsx] ";
        this.state = {}
    }


    onChange(event) {
        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            event.target.value = event.target.value;
            this.props.onChange(event);
        }
    }

    render() {
        console.log(this.componentName + 'RENDER: ' + this.props.id);

        let formClass = 'form';
        if (this.props.componentClass === null || this.props.componentClass === undefined) {
            formClass = formClass + 'mt-3 col-6 ';
        } else {
            formClass = formClass + this.props.componentClass;
        }

        let name = null;
        if (this.props.name === undefined) {
            name = this.props.id;
        } else {
            name = this.props.name;
        }

        let isDisabled;
        if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
            isDisabled = false;
        } else {
            isDisabled = true;
        }

        let label = null;
        if (this.props.label === undefined) {
            label = name;
        } else {
            label = this.props.label;
        }

        let myValue;
        if (this.props.value === undefined || this.props.value === null) {
            myValue = '';
        } else {
            myValue = this.props.value;
        }
        let myMin;
        if (this.props.min === undefined || this.props.min === null) {
            myMin = 0;
        } else {
            myMin = this.props.min;
        }
        let myMax;
        if (this.props.max === undefined || this.props.max === null) {
            myMax = 100;
        } else {
            myMax = this.props.max;
        }
        let unitaMisura;
        if (this.props.unitaMisura === undefined || this.props.unitaMisura === null) {
            unitaMisura = "";
        } else {
            unitaMisura = this.props.unitaMisura;
        }

        return (
            // <div  >
            <div className="form-group d-flex justify-content-center my-4 mt-3 col-6">
                <label key='labelSlider ' className='mr-3' htmlFor={this.props.id} >  {label} </label>

                <input id={this.props.id} className="custom-range" type="range" disabled={isDisabled} onChange={this.onChange} value={myValue} min={myMin} max={myMax} />
                <span className="font-weight-bold blue-text ml-2 " >{myValue + unitaMisura}</span>
            </div>
        );
    }
};

export default rangeSlider;